import { useTranslation } from "react-i18next";
import {
	MessageSeverity,
	MessageSize,
	UiMessageProps,
} from "../../models/components/field-message.model";
import { classNames } from "primereact/utils";

const UiMessage = (props: UiMessageProps | undefined) => {
	const { t } = useTranslation("common");

	const setIcon = (severity: MessageSeverity): string => {
		let icon: string = "ui-message__icon ";
		switch (severity) {
			case MessageSeverity.INFO:
				icon += "pi pi-info-circle";
				break;
			case MessageSeverity.SUCCESS:
				icon += "pi pi-check-circle";
				break;
			case MessageSeverity.WARNING:
				icon += "pi pi-exclamation-triangle";
				break;
			case MessageSeverity.DANGER:
				icon += "pi pi-times-circle";
				break;
			case MessageSeverity.LOADING:
				icon += "pi pi-spin pi-spinner";
				break;
			default:
				console.warn("Severity not found");
				break;
		}
		return icon;
	};

	return (
		<>
			{props && (props.severity || props.label) && (
				<small
					className={classNames(
						"ui-message",
						props.severity,
						props.size ?? MessageSize.MD
					)}
				>
					<i className={setIcon(props.severity)}></i>
					<span className="ui-message__label">{t(props.label)}</span>
				</small>
			)}
		</>
	);
};

export default UiMessage;
